import {  Injectable, Inject, Component, ViewChild, Input, Output } from '@angular/core';

import { StorageProvider } from '../../providers/storage-provider';
import { UtilProvider } from '../../providers/util-provider';

export const PREFIX = '--';

@Component({
    selector: 'refresh-info',
    template: '<div class="refresh-info" style="padding: 15px;font-size: 12px">{{ text }}</div>'
})
export class RefreshInfoComponent {


    @Input('date')
    date: string;

    text: string;

    constructor() {
      
    }


    ngOnInit() {
        this.text = 'Sua última atualização de dados foi em: ' + this.date;
    }

}


// WEBPACK FOOTER //
// ./src/components/refresh-info/refresh-info.component.ts